/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-console */

import moment from 'moment';

import { USE_PRODUCT_FAILURE, USE_PRODUCT_REQUEST, USE_PRODUCT_SUCCESS } from 'actions/product/saveUseProduct.types';
import isEmptyObject from 'utils/predicates/object/isEmptyObject.util';

import { SALES_REPORT_SUCCESS } from 'reports/actions';
import {
  ADD_TO_BASKET_ITEMS,
  APPLY_FILTERS,
  BULK_UPDATE_FAILURE,
  BULK_UPDATE_REQUEST,
  BULK_UPDATE_SUCCESS,
  CLEAR_FILTER,
  DELETE_ORDER_ITEM,
  DELETE_ORDER_SUCCESS,
  DELETE_STOCK_FAILURE,
  DELETE_STOCK_REQUEST,
  DELETE_STOCK_SUCCESS,
  EDIT_MAX_STOCK_FAILURE,
  EDIT_MAX_STOCK_REQUEST,
  EDIT_MAX_STOCK_SUCCESS,
  EDIT_MIN_STOCK_FAILURE,
  EDIT_MIN_STOCK_REQUEST,
  EDIT_MIN_STOCK_SUCCESS,
  EDIT_ORDER_ITEM,
  EDIT_STOCK_FAILURE,
  EDIT_STOCK_REQUEST,
  EDIT_STOCK_SUCCESS,
  EMPTY_ORDER_BASKET_FAILURE,
  EMPTY_ORDER_BASKET_REQUEST,
  EMPTY_ORDER_BASKET_SUCCESS,
  GENERATE_STOCK_ORDER_FAILURE,
  GENERATE_STOCK_ORDER_REQUEST,
  GENERATE_STOCK_ORDER_SUCCESS,
  GET_BASKET_FAILURE,
  GET_BASKET_REQUEST,
  GET_BASKET_SUCCESS,
  IMPORT_BULK_ORDER_SUCCESS,
  LAST_STOCK_ORDER_FAILURE,
  LAST_STOCK_ORDER_REQUEST,
  LAST_STOCK_ORDER_SUCCESS,
  LOAD_BRANDS_FAILURE,
  LOAD_BRANDS_REQUEST,
  LOAD_BRANDS_SUCCESS,
  LOAD_CATEGORIES_FAILURE,
  LOAD_CATEGORIES_REQUEST,
  LOAD_CATEGORIES_SUCCESS,
  LOAD_ORDER_LIST_FAILURE,
  LOAD_ORDER_LIST_REQUEST,
  LOAD_ORDER_LIST_SUCCESS,
  LOAD_SUB_BRANDS_FAILURE,
  LOAD_SUB_BRANDS_REQUEST,
  LOAD_SUB_BRANDS_SUCCESS,
  ORDER_DETAILS_SUCCESS,
  PUSH_MSG_UPDATE_STOCK,
  QR_DATA_FAILURE,
  QR_DATA_REQUEST,
  QR_DATA_SUCCESS,
  REVERT_COST_RETAIL_PRICE,
  SAVE_BASKET_FAILURE,
  SAVE_BASKET_REQUEST,
  SAVE_BASKET_SUCCESS,
  SCAN_ORDER_SUCCESS,
  SELECT_ALL_ITEMS,
  SELECT_ALL_ORDER_ITEMS,
  SELECT_ITEM,
  SELECT_ORDER_ITEM,
  SET_FILTER_VALUE,
  SORT_DATA,
  STOCK_COUNT_FAILURE,
  STOCK_COUNT_REQUEST,
  STOCK_COUNT_SUCCESS,
  STOCK_DATA_FAILURE,
  STOCK_DATA_REQUEST,
  STOCK_DATA_SUCCESS,
  TICK_ORDER_SELECT_ALL,
  TICK_SELECT_ALL,
  TOGGLE_FILTER,
  UPDATE_COST_PRICE,
  UPDATE_RETAIL_PRICE,
} from 'stocks/actions';
import { applyFilters, initFilters, sortStockList, toggleFilter, upgradeStock } from 'stocks/utils';

const UNKNOWN = 'Unknown';

function editStock(state, editedElement, editFilters, updateApiData) {
  const stock = { ...state.stock };
  const itemThatWillBeEdited = stock.apiData.find((el) => el.id === editedElement.id);
  const changedEditedElement = {
    ...itemThatWillBeEdited,
    ...editedElement,
    manufacturer_product: {
      ...(itemThatWillBeEdited && itemThatWillBeEdited.manufacturer_product),
      ...(editedElement && editedElement.manufacturer_product),
    },
  };

  if (isEmptyObject(changedEditedElement.manufacturer_product)) {
    changedEditedElement.manufacturer_product = {
      name: changedEditedElement.title || UNKNOWN,
      brand: UNKNOWN,
      family: UNKNOWN,
      sub_brand: UNKNOWN,
      category_name: UNKNOWN,
    };
  }

  stock.isPosting = false;

  if (updateApiData) {
    const ind = stock.apiData.findIndex((el) => el.id === editedElement.id);
    if (ind === -1) {
      stock.apiData.push(upgradeStock({ ...changedEditedElement }));
    } else {
      stock.apiData.splice(ind, 1, upgradeStock({ ...changedEditedElement }));
    }
  }

  if (editedElement.selected === false && updateApiData === false) {
    changedEditedElement.cost_price = itemThatWillBeEdited.cost_price;
    changedEditedElement.price = itemThatWillBeEdited.price;
  }

  const sortInd = stock.sorted.findIndex((el) => el.id === editedElement.id);

  let loadSorted = true;

  if (editFilters) {
    if (itemThatWillBeEdited.brand !== editedElement.brand || itemThatWillBeEdited.sub_brand !== editedElement.sub_brand || itemThatWillBeEdited.category_name !== editedElement.category_name) {
      stock.filters = initFilters(stock.apiData, stock.filters);
      const sortedData = stock.apiData.map((p) => ({ ...p, selected: false }));

      stock.sorted = sortedData.sort((a, b) => (a.brand ? a.brand.localeCompare(b.brand) : 0));
      loadSorted = false;
    }
  }

  if (loadSorted) {
    if (sortInd === -1) {
      if (!changedEditedElement.brand) {
        changedEditedElement.brand = UNKNOWN;
      }

      stock.sorted.push(upgradeStock({ ...changedEditedElement }));
    } else {
      stock.sorted.splice(sortInd, 1, upgradeStock({ ...changedEditedElement }));
    }
  }

  stock.filtered = applyFilters(stock.apiData, stock.filters);

  const updatedStockList = [...stock.orderingData];

  const updateBasketItem = updatedStockList.find((c) => c.id === editedElement.id);
  const indOrder = updatedStockList.findIndex((el) => el.id === editedElement.id);

  if (indOrder === -1) {
    updatedStockList.push(
      upgradeStock({
        ...changedEditedElement,
      }),
    );
  }

  if (updateBasketItem && updateBasketItem.length > 0) {
    changedEditedElement.isInBasket = updateBasketItem.isInBasket;
    changedEditedElement.selected = updateBasketItem.selected;

    updatedStockList.splice(
      indOrder,
      1,
      upgradeStock({
        ...updateBasketItem,
        ...changedEditedElement,
      }),
    );
  }

  stock.orderingData = updatedStockList;

  if (editFilters) {
    stock.orderingData = applyFilters(stock.apiData, stock.filters).map((p) => ({
      ...p,
      selected: false,
      isInBasket: false,
    }));
  }

  return { ...state, stock };
}

function editOrderStock(state, editedElement) {
  const stock = Object.assign({}, state.stock);
  stock.isPosting = false;
  const updatedStockList = [...stock.orderingData];
  const ind = updatedStockList.findIndex((el) => el.id === editedElement.id);

  if (ind === -1) {
    updatedStockList.push(upgradeStock(editedElement));
  } else {
    updatedStockList.splice(ind, 1, upgradeStock(editedElement));
  }

  stock.orderingData = updatedStockList;
  return { ...state, stock };
}

const stockManagementReducer = (
  state = {
    stock: {
      isFetching: false,
      errorMessage: '',
      isPosting: false,
      apiData: [],
      orderingData: [],
      filtered: [],
      sorted: [],
      filters: [],
      sortOrder: [],
      stockCountRequest: {
        isFetching: false,
        errorMessage: '',
      },
      currentOrderDetails: null,
      orderItems: [],
      allOrderItemsSelected: false,
      allItemsSelected: false,
      basketSaved: false,
      brandList: [],
      subBrandList: [],
      categoryList: [],
      lastOrderDate: null,
      geratedOrderNumber: null,
      updateEdit: false,
    },
    stockOrder: {
      isFetching: false,
      orderList: [],
    },
    auth: {
      isFetching: false,
      errorMessage: '',
      tokenData: null,
    },
  },
  action,
) => {
  if (action && action.type) {
    switch (action.type) {
      case STOCK_DATA_REQUEST: {
        const stock = Object.assign({}, state.stock);
        stock.isFetching = true;
        stock.errorMessage = '';
        return { ...state, stock };
      }
      case STOCK_DATA_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        stock.isFetching = false;
        stock.errorMessage = '';
        stock.apiData = action.response.map((el) => {
          // sometimes they come as null so we have to put unknown data
          if (!el.manufacturer_product) {
            el.manufacturer_product = {
              name: el.title || UNKNOWN,
              brand: UNKNOWN,
              family: UNKNOWN,
              sub_brand: UNKNOWN,
              category_name: UNKNOWN,
            };
          } else {
            // sometimes (it looks like) the manufactorer_product is coming but the brand or the sub_brand is null...
            // so we have to take care of that also
            if (!el.manufacturer_product.brand) {
              el.manufacturer_product.brand = UNKNOWN;
            } else if (!el.brand) {
              el.brand = el.manufacturer_product.brand;
            }
            if (!el.manufacturer_product.sub_brand) {
              el.manufacturer_product.sub_brand = UNKNOWN;
            } else if (!el.sub_brand) {
              el.sub_brand = el.manufacturer_product.sub_brand;
            }

            // NOTE: filters depend on same prop being in both el and el.manufacturer_product
            if (!el.manufacturer_product.category) {
              el.manufacturer_product.category = UNKNOWN;
              el.manufacturer_product.category_name = UNKNOWN;
            } else if (!el.category_name) {
              el.category_name = el.manufacturer_product.category;
              el.manufacturer_product.category_name = el.manufacturer_product.category;
            }

            if (!el.manufacturer_product.name) {
              el.manufacturer_product.name = UNKNOWN;
            } else if (!el.title) {
              el.title = el.manufacturer_product.name;
            }
          }

          if (el.brand === null) {
            el.brand = UNKNOWN;
          }
          return upgradeStock(el);
        });

        const copyArray = [...stock.apiData];
        // if we don't have any filters create a new ones with all available values
        if (stock.filters.length === 0) {
          stock.filters = initFilters(copyArray);
        } else {
          stock.filters = initFilters(copyArray, stock.filters);
        }
        // removed mapStocks()
        const results = applyFilters(copyArray, stock.filters);
        const sortedData = results.map((p) => ({ ...p, selected: false }));
        stock.filtered = sortedData;

        stock.sorted = sortedData.sort((a, b) => (a.brand ? a.brand.localeCompare(b.brand) : 0));
        stock.orderingData = applyFilters(copyArray, stock.filters).map((p) => ({
          ...p,
          selected: false,
          isInBasket: false,
        }));
        return { ...state, stock };
      }
      case STOCK_DATA_FAILURE: {
        const stock = Object.assign({}, state.stock);
        stock.isFetching = false;
        stock.errorMessage = action.errorMessage;
        return { ...state, stock };
      }
      case STOCK_COUNT_REQUEST: {
        const stock = Object.assign({}, state.stock);
        stock.stockCountRequest.isFetching = true;
        stock.stockCountRequest.errorMessage = '';
        return { ...state, stock };
      }
      case STOCK_COUNT_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        stock.apiData = stock.apiData.map((data) => {
          const usedSoldInRange = action.response.find((soldData) => soldData.id === data.id);
          if (usedSoldInRange) {
            data.usedSoldInRangeData = {
              sold: usedSoldInRange.sold,
              used: usedSoldInRange.used,
            };
          } else {
            // no product found in the time range, so it's 0
            data.usedSoldInRangeData = {
              sold: 0,
              used: 0,
            };
          }
          return data;
        });
        const results = applyFilters(stock.apiData, stock.filters);
        const filterList = results.map((p) => ({ ...p, selected: false }));
        stock.filtered = filterList;

        stock.sorted = filterList.sort((a, b) => (a.brand ? a.brand.localeCompare(b.brand) : 0));
        return { ...state, stock };
      }
      case STOCK_COUNT_FAILURE: {
        const stock = Object.assign({}, state.stock);
        stock.stockCountRequest.isFetching = false;
        stock.stockCountRequest.errorMessage = action.errorMessage;
        return { ...state, stock };
      }

      case SALES_REPORT_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        stock.apiData = stock.apiData.map((data) => {
          const revenueForRange = action.response.product_group.find((revenueData) => revenueData.id === data.id);
          if (revenueForRange) {
            data.revenueForRange = {
              total: revenueForRange.total,
            };
          } else {
            data.revenueForRange = {
              total: 0,
            };
          }
          return data;
        });

        stock.filtered = applyFilters(stock.apiData, stock.filters);

        return { ...state, stock };
      }
      case EDIT_STOCK_REQUEST:
      case EDIT_MIN_STOCK_REQUEST:
      case EDIT_MAX_STOCK_REQUEST: {
        const stock = Object.assign({}, state.stock);
        stock.isPosting = true;
        stock.errorMessage = '';
        return { ...state, stock };
      }
      case EDIT_STOCK_SUCCESS: {
        return editStock(state, action.params.editedElement, action.params.editFilters, true);
      }
      case EDIT_MIN_STOCK_SUCCESS:
      case EDIT_MAX_STOCK_SUCCESS: {
        return editStock(state, action.params.editedElement, false, true);
      }
      case EDIT_STOCK_FAILURE:
      case EDIT_MIN_STOCK_FAILURE:
      case EDIT_MAX_STOCK_FAILURE: {
        const stock = Object.assign({}, state.stock);
        stock.isPosting = false;
        stock.errorMessage = action.errorMessage;
        return { ...state, stock };
      }
      case DELETE_STOCK_REQUEST: {
        const stock = Object.assign({}, state.stock);
        stock.isPosting = true;
        stock.errorMessage = '';
        return { ...state, stock };
      }
      case DELETE_STOCK_SUCCESS: {
        const deletedId = action.params.productId;
        const stock = Object.assign({}, state.stock);
        stock.isPosting = false;
        const oldLength = stock.apiData.length;
        stock.apiData = stock.apiData.filter((el) => el.id !== deletedId);
        const newLength = stock.apiData.length;

        if (oldLength !== newLength) {
          stock.filters = initFilters(stock.apiData, stock.filters);
          stock.filtered = applyFilters(stock.apiData, stock.filters);

          stock.sorted = stock.filtered;
        }

        return { ...state, stock };
      }
      case DELETE_STOCK_FAILURE: {
        const stock = Object.assign({}, state.stock);
        stock.isPosting = false;
        stock.errorMessage = action.errorMessage;
        return { ...state, stock };
      }
      case QR_DATA_REQUEST: {
        const auth = Object.assign({}, state.auth);
        auth.isFetching = true;
        auth.errorMessage = '';
        return { ...state, auth };
      }
      case QR_DATA_SUCCESS: {
        const auth = Object.assign({}, state.auth);
        auth.isFetching = false;
        auth.errorMessage = '';
        auth.tokenData = action.response;

        return { ...state, auth };
      }
      case QR_DATA_FAILURE: {
        const auth = Object.assign({}, state.auth);
        auth.isFetching = false;
        auth.errorMessage = action.errorMessage;
        return { ...state, auth };
      }
      case TOGGLE_FILTER: {
        const stock = Object.assign({}, state.stock);
        stock.filters = toggleFilter(stock.filters, action.filter, action.valueToToggle);

        return { ...state, stock };
      }
      case SET_FILTER_VALUE: {
        const stock = Object.assign({}, state.stock);
        stock.filters = toggleFilter(stock.filters, action.filter, action.valueToToggle, action.setValue);

        return { ...state, stock };
      }
      case CLEAR_FILTER: {
        const stock = Object.assign({}, state.stock);
        stock.allItemsSelected = false;
        const clearApiSelection = stock.apiData.map((p) => ({ ...p, selected: false }));
        stock.apiData = clearApiSelection;
        stock.filters = initFilters(stock.apiData, stock.filters);
        const filteredList = applyFilters(stock.apiData, stock.filters);
        filteredList.map((p) => ({ ...p, selected: false }));
        stock.filtered = filteredList;
        stock.orderingData = filteredList.map((p) => ({
          ...p,
          selected: false,
          isInBasket: stock.orderItems.some((c) => c.product === p.id),
        }));
        stock.sorted = sortStockList(
          stock.sortOrder,
          stock.apiData.map((p) => ({ ...p, selected: false })),
          '',
        );

        return { ...state, stock };
      }
      case PUSH_MSG_UPDATE_STOCK: {
        return editStock(state, action.data.data.data, false, true); // yep that's 3 .data in a row
      }
      case SORT_DATA: {
        const stock = Object.assign({}, state.stock);
        let newSortItemData = [...stock.sortOrder];
        const sortList = applyFilters(stock.apiData, stock.filters);
        const newSortList = [...sortList];
        const sortOptionString = action.sortOption;
        if (newSortItemData.indexOf(sortOptionString) > -1) {
          if (newSortItemData.filter((c) => c === sortOptionString).length > 1) {
            // if sortStrig cout is 2 im the list
            // remove it from the list and set the list to default order

            newSortItemData = newSortItemData.filter((f) => f !== sortOptionString);
          } else {
            // if the sortStrig appears once in the list -> order asc
            newSortItemData.push(sortOptionString);
          }
        } else {
          // Sort desc and put it in the string
          newSortItemData.push(sortOptionString);
        }

        stock.sortOrder = newSortItemData;
        stock.sorted = sortStockList(newSortItemData, newSortList, sortOptionString);
        return { ...state, stock };
      }
      case APPLY_FILTERS: {
        const stock = { ...state.stock };
        const filteredList = applyFilters(stock.apiData, stock.filters);

        stock.orderingData = filteredList.map((p) => ({
          ...p,
          selected: false,
          isInBasket: stock.orderItems.some(({ product }) => product === p.id),
        }));

        stock.sorted = sortStockList(
          stock.sortOrder,
          filteredList.map((p) => ({ ...p, selected: false })),
          '',
        );
        return { ...state, stock };
      }
      case SELECT_ALL_ITEMS: {
        const stock = Object.assign({}, state.stock);
        const selectionValue = action.isChecked;

        const calcSorted = stock.sorted.map((p) => ({ ...p, selected: selectionValue }));
        const clearApiSelection = stock.apiData.map((p) => ({ ...p, selected: selectionValue }));
        stock.apiData = clearApiSelection;
        stock.sorted = sortStockList(stock.sortOrder, calcSorted, '');
        stock.allItemsSelected = selectionValue;
        return { ...state, stock };
      }
      case TICK_SELECT_ALL: {
        const stock = Object.assign({}, state.stock);
        stock.allItemsSelected = action.setSelectAll;
        return { ...state, stock };
      }
      case TICK_ORDER_SELECT_ALL: {
        const stock = Object.assign({}, state.stock);
        stock.allOrderItemsSelected = action.setSelectAll;
        return { ...state, stock };
      }
      case SELECT_ALL_ORDER_ITEMS: {
        const stock = Object.assign({}, state.stock);
        const selectionValue = action.setSelectAll;
        stock.orderingData = stock.orderingData.map((p) => ({ ...p, selected: selectionValue }));
        stock.allOrderItemsSelected = action.setSelectAll;
        return { ...state, stock };
      }
      case SELECT_ITEM: {
        return editStock(state, action.updateItem, false, false);
      }
      case SELECT_ORDER_ITEM: {
        return editOrderStock(state, action.updateItem);
      }
      case LOAD_CATEGORIES_REQUEST:
      case LOAD_CATEGORIES_FAILURE:
      case BULK_UPDATE_REQUEST:
      case BULK_UPDATE_FAILURE:
      case SAVE_BASKET_REQUEST:
      case SAVE_BASKET_FAILURE:
      case LOAD_BRANDS_REQUEST:
      case LOAD_BRANDS_FAILURE:
      case LOAD_SUB_BRANDS_REQUEST:
      case LOAD_SUB_BRANDS_FAILURE:
      case GENERATE_STOCK_ORDER_REQUEST:
      case GENERATE_STOCK_ORDER_FAILURE:
      case LAST_STOCK_ORDER_REQUEST:
      case LAST_STOCK_ORDER_FAILURE:
      case GET_BASKET_REQUEST:
      case GET_BASKET_FAILURE:
      case EMPTY_ORDER_BASKET_REQUEST:
      case EMPTY_ORDER_BASKET_FAILURE:
      case LOAD_ORDER_LIST_REQUEST:
      case LOAD_ORDER_LIST_FAILURE:
        return { ...state };
      case BULK_UPDATE_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        const dataUpdate = action.params.data;
        const updatedStockList = [...stock.apiData];
        const newBrandName = dataUpdate[0].brand_name;
        const newSubBrandName = dataUpdate[0].sub_brand_name;
        const newCategoryName = dataUpdate[0].category_name;

        updatedStockList.forEach((item) => {
          const editedItem = item;
          const dataFound = dataUpdate.find((c) => c.id === item.id);
          if (dataFound) {
            if (newBrandName !== '') {
              editedItem.brand = newBrandName;
            }
            if (newSubBrandName !== '') {
              editedItem.sub_brand = newSubBrandName;
            }
            if (newCategoryName !== '') {
              editedItem.category_name = newCategoryName;
            }
            if (dataFound.cost_price) {
              editedItem.cost_price = dataFound.cost_price.toFixed(2);
            }
            if (dataFound.retail_price) {
              editedItem.price = dataFound.retail_price;
            }

            const ind = stock.apiData.findIndex((el) => el.id === editedItem.id);
            if (ind === -1) {
              stock.apiData.push(upgradeStock(editedItem));
            } else {
              stock.apiData.splice(ind, 1, upgradeStock(editedItem));
            }

            editedItem.selected = false;
            const sortInd = stock.sorted.findIndex((el) => el.id === editedItem.id);
            if (sortInd === -1) {
              stock.sorted.push(upgradeStock(editedItem));
            } else {
              stock.sorted.splice(sortInd, 1, upgradeStock(editedItem));
            }
          }
          const updatedOrderList = [...stock.orderingData];
          const updateBasketItem = updatedOrderList.filter((c) => c.id === editedItem.id);
          if (updateBasketItem.length > 0) {
            const updatedItem = updateBasketItem[0];
            editedItem.isInBasket = updatedItem.isInBasket;
            editedItem.selected = updatedItem.selected;
            const indOrder = updatedStockList.findIndex((el) => el.id === editedItem.id);

            if (indOrder === -1) {
              updatedStockList.push(upgradeStock(editedItem));
            } else {
              updatedStockList.splice(indOrder, 1, upgradeStock(editedItem));
              stock.orderingData = updatedStockList;
            }
          }
          return true;
        });

        stock.allItemsSelected = false;
        stock.filtered = applyFilters(stock.apiData, stock.filters);
        return { ...state, stock };
      }
      case ADD_TO_BASKET_ITEMS: {
        const stock = Object.assign({}, state.stock);
        const stockOrderList = [...stock.orderingData];
        const editOrderData = [...stock.orderItems];
        stock.allItemsSelected = false;

        stock.orderingData = stockOrderList.map((orderItem) => {
          if (!orderItem.selected || orderItem.isInBasket) {
            return orderItem;
          }
          let calQuantity = 1;
          if (orderItem.max_in_stock) {
            calQuantity = orderItem.max_in_stock - orderItem.units_in_stock;
          }
          if (calQuantity < 1) {
            calQuantity = 1;
          }
          editOrderData.push({
            product: orderItem.id,
            quantity: Math.round(calQuantity),
            title: orderItem.title,
            cost_price: orderItem.cost_price,
            brand: orderItem.brand,
            sub_brand: orderItem.sub_brand,
            category_name: orderItem.category_name,
            barcode: orderItem.barcode,
          });
          return upgradeStock({ ...orderItem, isInBasket: true });
        });
        stock.orderItems = editOrderData;
        stock.basketSaved = false;
        return { ...state, stock };
      }
      case DELETE_ORDER_ITEM: {
        const stock = Object.assign({}, state.stock);
        const updateOrderList = [...stock.orderItems];
        const stockOrderList = [...stock.orderingData];
        const actionItem = action.orderItem;
        stockOrderList.forEach((orderItem) => {
          if (orderItem.id === actionItem.product) {
            const editItem = orderItem;
            editItem.selected = false;
            editItem.isInBasket = false;
            const ind = stockOrderList.findIndex((el) => el.id === editItem.id);

            if (ind === -1) {
              stockOrderList.push(upgradeStock(editItem));
            } else {
              stockOrderList.splice(ind, 1, upgradeStock(editItem));
            }
          }
        });
        stock.orderItems = updateOrderList.filter((c) => c.product !== actionItem.product);
        stock.orderingData = stockOrderList;
        stock.basketSaved = false;

        return { ...state, stock };
      }
      case EDIT_ORDER_ITEM: {
        const stock = Object.assign({}, state.stock);
        const updateOrderList = [...stock.orderItems];

        const actionItem = action.orderItem;
        const ind = updateOrderList.findIndex((el) => el.product === actionItem.product);

        if (ind === -1) {
          updateOrderList.push(actionItem);
        } else {
          updateOrderList.splice(ind, 1, actionItem);
        }

        stock.basketSaved = false;
        stock.orderItems = updateOrderList;
        return { ...state, stock };
      }
      case EMPTY_ORDER_BASKET_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        const stockOrderList = [...stock.orderingData];
        stock.basketSaved = false;

        stock.allItemsSelected = false;
        stock.orderItems = [];
        stock.orderingData = stockOrderList.map((p) => ({ ...p, selected: false, isInBasket: false }));
        return { ...state, stock };
      }
      case SAVE_BASKET_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        stock.basketSaved = true;

        return { ...state, stock };
      }
      case LOAD_BRANDS_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        stock.brandList = action.response;
        return { ...state, stock };
      }
      case LOAD_SUB_BRANDS_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        stock.subBrandList = action.response;
        return { ...state, stock };
      }
      case LOAD_CATEGORIES_SUCCESS: {
        const { stock } = state;
        stock.categoryList = [...new Set(action.response)];
        return { ...state, stock };
      }
      case GENERATE_STOCK_ORDER_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        const response = action.response;
        stock.lastOrderDate = response.created_at;
        stock.geratedOrderNumber = response.number;
        return { ...state, stock };
      }
      case LAST_STOCK_ORDER_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        const stockOrderList = [...stock.orderingData];
        const orderingEditData = stockOrderList.map((p) => ({ ...p, selected: false, isInBasket: false }));

        const response = action.response;
        stock.lastOrderDate = response.created_at;
        const loadProducts = action.params.isBtnClicked;
        if (loadProducts) {
          const addOrderItems = action.response.ordered_products;
          const lastOrderData = [];
          addOrderItems.forEach((item) => {
            const findStockItem = stock.apiData.filter((c) => c.id === item.product);
            const editItem = findStockItem[0];
            if (findStockItem.length > 0) {
              const addOrderItem = {
                product: item.product,
                quantity: item.quantity,
                title: item.title ? item.title : editItem.title,
                cost_price: item.price ? item.price : 0,
                brand: editItem.brand,
                sub_brand: editItem.sub_brand,
                category_name: editItem.category_name,
                barcode: editItem.barcode,
              };

              lastOrderData.push(addOrderItem);
              editItem.isInBasket = true;
              const ind = orderingEditData.findIndex((el) => el.id === editItem.id);

              if (ind === -1) {
                orderingEditData.push(upgradeStock(editItem));
              } else {
                orderingEditData.splice(ind, 1, upgradeStock(editItem));
              }
            }
          });
          stock.orderItems = lastOrderData;
          stock.orderingData = orderingEditData;
        }
        return { ...state, stock };
      }
      case GET_BASKET_SUCCESS: {
        const stock = Object.assign({}, state.stock);
        const stockOrderList = [...stock.orderingData];
        const orderingEditData = stockOrderList.map((p) => ({ ...p, selected: false, isInBasket: false }));

        const addOrderItems = action.response.products;
        const savedOrderData = [];
        addOrderItems.forEach((item) => {
          const findStockItem = stock.apiData.filter((c) => c.id === item.product);
          const editItem = findStockItem[0];
          if (findStockItem.length > 0) {
            const addOrderItem = {
              product: item.product,
              quantity: item.quantity,
              title: item.title ? item.title : findStockItem[0].title,
              cost_price: item.cost_price ? item.cost_price : 0,
              brand: findStockItem[0].brand,
              sub_brand: findStockItem[0].sub_brand,
              category_name: findStockItem[0].category_name,
              barcode: findStockItem[0].barcode,
            };
            savedOrderData.push(addOrderItem);
            editItem.isInBasket = true;
            const ind = orderingEditData.findIndex((el) => el.id === editItem.id);

            if (ind === -1) {
              orderingEditData.push(upgradeStock(editItem));
            } else {
              orderingEditData.splice(ind, 1, upgradeStock(editItem));
            }
          }
        });
        stock.orderItems = savedOrderData;
        stock.orderingData = orderingEditData;
        stock.basketSaved = true;
        return { ...state, stock };
      }
      case UPDATE_COST_PRICE: {
        const stock = Object.assign({}, state.stock);
        const updatedStockList = [...stock.sorted];
        const updatePercent = action.percent;
        const paramCost = action.newCost;

        const newSorted = [];
        updatedStockList.forEach((item) => {
          const editedItem = item;
          if (item.selected === true) {
            if (stock.sorted.filter((c) => c.selected === true && c.id === item.id).length > 0) {
              if (paramCost !== '') {
                editedItem.cost_price = paramCost;
              } else if (updatePercent !== '') {
                const calcPercentage = (parseFloat(item.cost_price) / 100) * parseInt(updatePercent, 10);
                if (action.incrCost) {
                  const calcValue = parseFloat(item.cost_price) + calcPercentage;
                  editedItem.cost_price = calcValue ? calcValue.toFixed(2) : '';
                } else {
                  const calcValue = parseFloat(item.cost_price) - calcPercentage;
                  editedItem.cost_price = calcValue ? calcValue.toFixed(2) : '';
                }
              }
            }
          } else {
            const blankPrice = stock.apiData.filter((c) => c.id === item.id);
            editedItem.price = blankPrice[0].price;
            editedItem.cost_price = blankPrice[0].cost_price ? blankPrice[0].cost_price : '';
          }
          newSorted.push(editedItem);
        });
        stock.sorted = newSorted;
        stock.updateEdit = false;
        return { ...state, stock };
      }
      case UPDATE_RETAIL_PRICE: {
        const stock = Object.assign({}, state.stock);
        const updatedStockList = [...stock.sorted];
        const updatePercent = action.percent;
        const paramReatil = action.newRetail;
        const roundParam = action.roundOption;
        const newSorted = [];
        updatedStockList.forEach((item) => {
          const editedItem = item;
          if (item.selected === true) {
            if (stock.sorted.filter((c) => c.selected === true && c.id === item.id).length > 0) {
              if (paramReatil !== '') {
                editedItem.price = parseFloat(paramReatil);
              } else if (updatePercent !== '') {
                const retailBlankPrice = state.stock.apiData.filter((c) => c.id === item.id);
                if (retailBlankPrice[0] && retailBlankPrice[0].price) {
                  const calcPerceentage = (parseFloat(retailBlankPrice[0].price) / 100) * parseFloat(updatePercent);
                  let calcValue = parseFloat(retailBlankPrice[0].price) + parseFloat(calcPerceentage);
                  if (!action.incrRetail) {
                    calcValue = parseFloat(retailBlankPrice[0].price) - parseFloat(calcPerceentage);
                  }
                  if (roundParam) {
                    if (roundParam === '49p') {
                      calcValue = Math.floor(calcValue) + 0.49;
                    }
                    if (roundParam === '50p') {
                      calcValue = Math.floor(calcValue) + 0.5;
                    }
                    if (roundParam === '99p') {
                      calcValue = Math.floor(calcValue) + 0.99;
                    }
                    if (roundParam === '£1') {
                      calcValue = Math.floor(calcValue) + 1;
                    }
                  }
                  editedItem.price = calcValue;
                }
              }
            }
          } else {
            const blankPrice = stock.apiData.filter((c) => c.id === item.id);
            editedItem.price = blankPrice[0].price;
            editedItem.cost_price = blankPrice[0].cost_price ? blankPrice[0].cost_price : '';
          }
          newSorted.push(editedItem);
        });
        stock.sorted = newSorted;
        stock.updateEdit = false;
        return { ...state, stock };
      }
      case REVERT_COST_RETAIL_PRICE: {
        const stock = Object.assign({}, state.stock);
        const updatedStockList = [...stock.sorted];
        const newSorted = [];
        updatedStockList.forEach((item) => {
          const editedItem = item;
          const blankPrice = state.stock.apiData.filter((c) => c.id === item.id);
          editedItem.price = blankPrice[0].price;
          editedItem.cost_price = blankPrice[0].cost_price;
          newSorted.push(editedItem);
        });
        let currrentOrder = stock.sortOrder;
        if (currrentOrder.length === 0) {
          currrentOrder = ['brand'];
        }
        stock.sorted = newSorted;
        stock.updateEdit = false;
        return { ...state, stock };
      }
      case LOAD_ORDER_LIST_SUCCESS: {
        const stockOrder = Object.assign({}, state.stockOrder);
        const comparator = (a, b) => (a.created_at && b.created_at ? moment(b.created_at) - moment(a.created_at) : 0);
        const orderedList = action.response.sort(comparator);
        stockOrder.orderList = orderedList;
        stockOrder.isFetching = false;
        return { ...state, stockOrder };
      }
      case SCAN_ORDER_SUCCESS: {
        const stockOrder = Object.assign({}, state.stockOrder);
        const orderList = [...stockOrder.orderList];
        const changeOrderList = [];
        const editId = action.params.orderId;
        orderList.forEach((item) => {
          const editedItem = item;
          if (editedItem.id === editId) {
            editedItem.scanned_at = moment();
          }
          changeOrderList.push(editedItem);
        });
        stockOrder.orderList = changeOrderList;
        return { ...state, stockOrder };
      }
      case DELETE_ORDER_SUCCESS: {
        const stockOrder = Object.assign({}, state.stockOrder);
        const orderList = [...stockOrder.orderList];
        const editId = action.params.orderId;
        const changeOrderList = orderList.filter((c) => c.id !== editId);
        stockOrder.orderList = changeOrderList;
        return { ...state, stockOrder };
      }
      case IMPORT_BULK_ORDER_SUCCESS: {
        const stockOrder = Object.assign({}, state.stockOrder);
        const orderList = [...stockOrder.orderList];
        const changeOrderList = [];
        let quantityCount = 0;
        const responseList = action.response;
        responseList.forEach((item) => {
          quantityCount += item.quantity_change;
        });
        const editId = action.params.orderId;
        orderList.forEach((item) => {
          const editedItem = item;
          if (editedItem.id === editId) {
            editedItem.imported_at = moment();
            editedItem.items_imported = quantityCount;
          }
          changeOrderList.push(editedItem);
        });
        stockOrder.orderList = changeOrderList;
        return { ...state, stockOrder };
      }
      case ORDER_DETAILS_SUCCESS: {
        const stockOrder = Object.assign({}, state.stockOrder);
        const editId = action.params.orderId;
        const responseProducts = action.response;
        const orderProduct = [];
        responseProducts.ordered_products.forEach((item) => {
          const editProduct = item;
          if (item.product.manufacturer_product) {
            if (item.product.title === null || item.product.title === '') {
              editProduct.product.title = item.product.manufacturer_product.name;
            }
            if (item.product.brand_name === null || item.product.brand_name === '') {
              editProduct.product.brand_name = item.product.manufacturer_product.brand_name;
            }
            if (item.product.sub_brand_name === null || item.product.sub_brand_name === '') {
              editProduct.product.sub_brand_name = item.product.manufacturer_product.sub_brand_name;
            }
            if (item.product.category_name === null || item.product.category_name === '') {
              // used to be item.product.manufacturer_product.category_name;
              editProduct.product.category_name = item.product.manufacturer_product.category;
            }
          }
          orderProduct.push(editProduct);
        });
        stockOrder.currentOrderDetails = {
          id: editId,
          productList: orderProduct,
          imported_productList: responseProducts.imported_products,
        };

        return { ...state, stockOrder };
      }
      case USE_PRODUCT_REQUEST: {
        return { ...state };
      }
      case USE_PRODUCT_SUCCESS: {
        return { ...state, responseProducts: action.response };
      }
      case USE_PRODUCT_FAILURE: {
        return { ...state, errorMessage: action.errorMessage };
      }
      default: {
        return state;
      }
    }
  }
  return state;
};

export default stockManagementReducer;
